import { AfterContentInit, Component, HostBinding, OnDestroy, OnInit } from '@angular/core'
import { MatIconRegistry } from '@angular/material/icon'
import { DomSanitizer } from '@angular/platform-browser'
import { Subscription } from 'rxjs'
import { CommandeService } from '../linge-hebergement/shared/commande.service'
import { Client } from '../shared/client/client'
import { ClientService } from '../shared/client/client.service'
import { MenuItem } from './shared/menu/menu-item'
import { MenuService } from './shared/menu/menu.service'

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: [
    '../shared/customer-area.scss',
    './home-page.component.scss'
  ]
})
export class HomePageComponent implements OnInit, AfterContentInit, OnDestroy {
  @HostBinding('class.clamp') clamp = true

  menuItems: Array<MenuItem> = new Array<MenuItem>()

  clientLoad: Subscription = new Subscription()
  load: Subscription = new Subscription()
  breakpoint: number
  currentClient: Client

  dateLivraison
  pendingDelivery: boolean

  subClient: Subscription

  hasDotations: boolean = false

  constructor(
    private menuService: MenuService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private clientService: ClientService,
    private commandeService: CommandeService,
  ) {
    this.getCountOrderInProcess()
    this.generateMatIcon()
    this.subClient = this.clientService.getCurrentClient().subscribe(client => {
      this.currentClient = client
      if (!this.currentClient.is_livraison_commande) {
        this.commandeService.getClientHasDotations(this.currentClient.id).subscribe(data => {
          this.hasDotations = data
        })
      }

      this.getCommandeOrderInProcess(client)
      this.getDateLivraison(client)

      this.menuService.getMenuItems(client).subscribe(
        menuItems => this.menuItems = menuItems
      )
    })
  }

  ngOnInit() {
    this.onResize(window.innerWidth)
  }

  ngAfterContentInit() {
  }

  ngOnDestroy() {
    this.load.unsubscribe()
    if (this.subClient) {
      this.subClient.unsubscribe()
    }
  }

  getCountOrderInProcess() {
    this.load.unsubscribe()
    this.load = this.menuService.countOrderInProcess().subscribe(
      demandeEnCours => {
        if (this.menuItems.find(item => item.id === 'order-tracking') !== undefined) {
          this.menuItems.find(item => item.id === 'order-tracking').nbNotif = demandeEnCours
        }
      }
    )
  }

  getCommandeOrderInProcess(client: Client) {
    this.load.unsubscribe()
    this.load = this.commandeService.countCommandeInprocess(client).subscribe(
      commandeEnCours => {
        if (this.menuItems.find(item => item.id === 'linge-hebergement') !== undefined) {
          this.menuItems.find(item => item.id === 'linge-hebergement').nbNotif = commandeEnCours
        }
      }
    )
  }

  /**
   * Génération des icones, compatibilité IE 11
   */
  generateMatIcon(): void {
    this.matIconRegistry.addSvgIcon(
      'daily-operation',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/pictogrammes/gestion-quotidien.svg')
    )
    this.matIconRegistry.addSvgIcon(
      'order-tracking',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/pictogrammes/fichier.svg')
    )
    this.matIconRegistry.addSvgIcon(
      'linge-hebergement',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/pictogrammes/linge.svg')
    )
    this.matIconRegistry.addSvgIcon(
      'delivery',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/pictogrammes/livraison.svg')
    )
    this.matIconRegistry.addSvgIcon(
      'billing',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/pictogrammes/facturation.svg')
    )
    this.matIconRegistry.addSvgIcon(
      'statistic',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/pictogrammes/stats.svg')
    )
    this.matIconRegistry.addSvgIcon(
      'cab',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/pictogrammes/puce.svg')
    )
    this.matIconRegistry.addSvgIcon(
      'dav',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/pictogrammes/dav.svg')
    )
    this.matIconRegistry.addSvgIcon(
      'bordereaux',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/pictogrammes/bordereaux.svg')
    )
  }

  onResize(event) {
    const x = event
    switch (true) {
      case (x <= 380):
        this.breakpoint = 1
        break
      case (x >= 381 && x <= 768):
        this.breakpoint = 2
        break
      case (x > 769):
        this.breakpoint = 4
        break
      default:
        this.breakpoint = 4
        break
    }
  }

  showNotifDeliveryToSend(menuItem) {
    return menuItem.id === "linge-hebergement" && this.currentClient.is_livraison_commande && this.pendingDelivery
  }

  getDateLivraison(client: Client) {
    if (client) {
      this.commandeService.commandeDelivery(client).subscribe(
        data => {
          this.dateLivraison = data["date_livraison"]
          this.pendingDelivery = data["pending_delivery"]
        }
      )
    }
  }

  getDisabledClass(menuItem) {
    switch (menuItem.id) {
      case 'linge-hebergement': {
        if (!this.currentClient.is_livraison_commande && !this.hasDotations) {
          return 'disable-tile'
        }
        break
      }
      case 'dav': {
        if (!this.currentClient.dav) {
          return 'disable-tile'
        }
        break
      }
    }
    return ''
  }

  getClickClass(menuItem) {
    if (this.getDisabledClass(menuItem) != 'disable-tile') {
      return 'click'
    }
    return ''
  }
}
